<template>
  <div class="h-full bg-light-blue page-container">
    <nav-bar>
      <template slot="left">
        <burger-navigation-item />
      </template>
    </nav-bar>
    <div>
      <div class="container mx-auto py-14 small-header-mb">
        <img src="../assets/logo-white.svg" class="w-1/2 mx-auto img-logo d-md-none"/>
      </div>
    </div><div class="bg-white h-full rounded-t-3xl">
    <div class="container max-w-sm mx-auto pt-content pb-20 px-4">
      <div class="mb-3">
        <h1 class="text-3xl font-display text-green text-center page-headline" v-html="pageTitle"></h1>
        <p class="text-black mt-2" v-if="coupons.length > 0" v-html="description"></p>
      </div>
      <Offline>
        <div class="w-full bg-black p-4 my-3">
          Din enhed er ikke forbundet til internettet, og derfor vil du ikke kunne indløse kuponner.
        </div>
      </Offline>
      <div v-if="this.$store.getters.ready" class="mt-8">
        <div v-if="this.coupons.length > 0">
          <div>
            <CustomDropdown
              v-if="tags.length > 0"
              :options="tags"
              placeholder="filter"
              @update:selected="filterSelect"
            />
          </div>
          <Coupon
            v-for="(coupon) in filterCoupons"
            :key="coupon.id"
            :coupon="coupon"
            @show-coupon="showCoupon(coupon)"
          />
          <div v-if="this.coupons.length > 0 && this.filterCoupons.length === 0">
            Der er i øjeblikket ingen aktive kuponer under denne kategori.
          </div>
        </div>
        <div v-else>
          Der er ikke nogle kuponer tilgængelig lige nu. Tjek igen senere.
        </div>
        <div class="w-full mb-4 mt-8 label-content">
        </div>
      </div>
      <div v-else>
        Indlæser..
      </div>
    </div>
  </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Coupon from '@/components/Coupon'
import NavBar from '@/components/NavBar'
import Offline from 'v-offline'
import BurgerNavigationItem from '@/components/BurgerNavigationItem'
import requiresAuthMixin from '../mixins/requiresAuth'
import { ContentAction } from '@/data/ContentAction'
import CustomDropdown from '@/components/CustomDropdown'

export default {
  name: 'Coupons',
  metaInfo: {
    title: 'Tilbud'
  },
  mixins: [
    requiresAuthMixin
  ],
  components: {
    CustomDropdown,
    BurgerNavigationItem,
    NavBar,
    Coupon,
    Offline
  },
  data () {
    return {
      pageTitle: '',
      description: '',
      filterTag: ''
    }
  },
  computed: {
    coupons () {
      return this.$store.state.coupons.filter(function (coupon) {
        return coupon.redeemed !== true
      }) ?? []
    },
    tags () {
      let tags = []
      if (this.coupons.length > 0) {
        tags = ['Sommerkupon', 'Forårskupon', 'TC-VIP', 'Personlige kuponer']
      }
      const couponTags = this.coupons.flatMap(coupon => coupon.tags).sort((a, b) => a.localeCompare(b)) ?? []
      tags = this.sortTags([...tags, ...couponTags])

      if (tags.length > 0) tags.unshift('Alle')
      return [...new Set(tags)]
    },
    filterCoupons () {
      if (!this.filterTag || this.filterTag === 'Alle') return this.coupons
      return this.coupons.filter(coupon => coupon.tags.some(tag => tag.includes(this.filterTag)))
    }
  },
  methods: {
    showCoupon (coupon) {
      this.$router.push({
        name: 'coupons.show',
        params: {
          id: coupon.id
        }
      })
    },
    loadContents () {
      const cachedContents = sessionStorage.getItem('pageContents')
      if (!cachedContents) {
        // ✅ Use cached theme
        try {
          ContentAction.contents().then((contents) => {
            sessionStorage.setItem('pageContents', JSON.stringify(contents.data))
            this.loadCouponContent(contents.data)
          })
        } catch (error) {
          console.error('Error loading contents:', error)
        }
      } else {
        this.loadCouponContent(JSON.parse(cachedContents))
      }
    },
    loadCouponContent (contents) {
      if (contents) {
        const pageContent = contents.find(p => p.title.toLowerCase() === 'coupons')
        if (pageContent) {
          this.pageTitle = pageContent.page_title
          this.description = pageContent.description
        }
      }
    },
    filterSelect (tag) {
      this.filterTag = tag
    },
    sortTags (items) {
      const priority = ['Sommerkupon', 'Forårskupon', 'Fødselsdagskupon', 'TC-VIP', 'Personlige kuponer']

      items.sort((a, b) => {
        const aIndex = priority.indexOf(a)
        const bIndex = priority.indexOf(b)

        // Both are priority items
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex
        }

        // Only a is priority
        if (aIndex !== -1) return -1

        // Only b is priority
        if (bIndex !== -1) return 1

        // Normal alphabetical sort
        return a.localeCompare(b)
      })
      return items
    }
  },
  mounted () {
    this.loadContents()
  }
}
</script>

<style>
.search-txt{
  width: 100%;
  padding: 15px;
  margin-bottom: 1rem;
  border-radius: 20px;
}
</style>
